import React from 'react'
import { Link } from "react-router-dom"

import logo from "../../assets/images/logo.svg"
import spongebob from "../../assets/images/spongebob1.svg"
import applelogo from "../../assets/images/applelogo.svg"
import playstore from "../../assets/images/playstore.svg"
import st from "../../assets/images/st.svg"
import sf from "../../assets/images/sf.svg"
import sig from "../../assets/images/sig.svg"
import sdis from "../../assets/images/sdis.svg"
import sli from "../../assets/images/sli.svg"
import "./lp.css"

const LandingPage = () => {
    return (
        <div className="lp">
            <Link to="/" className="mypipe-logo">
                <div className="logo-bg"><img src={logo} className="lp-logo" alt="MyPipe logo" /></div>
                <div className="lp-logo-text">
                    <h1 className="lp-logo-text_big">MyPipe</h1>
                    <h5 className="lp-logo-text_small">Beta</h5>
                </div>
            </Link>
            <h1 className="namaste-text">You’re here because this
                pipe contains<br /> something that interest you, right?
            </h1>
            <img src={spongebob} className="namaste-img" alt="namaste welcome" />
            <h1 className="namaste-download">
                Okay, download the app & Join us.<br /> Don’t forget to tell your friends too 😘
            </h1>
            <div className="apps">
                <div className="app-bg">
                    <img src={applelogo} alt="apple logo" />
                    <div className="app-t">
                        <span>Available on</span>
                        <p>App store</p>
                    </div>
                </div>
                {/*  */}
                <div className="app-bg">
                    <img src={playstore} alt="apple logo" />
                    <div className="app-t">
                        <span>Available on</span>
                        <p>Google Play</p>
                    </div>
                </div>
            </div>
            <div className="socials">
                <p>Let’s stay connected on all socials</p>
                <div className="socials-icon">
                    <img src={st} alt="twitter" />
                    <img src={sf} alt="facebook" />
                    <img src={sig} alt="instagram" />
                    <img src={sdis} alt="discord" />
                    <img src={sli} alt="linkedin" />
                </div>
            </div>
            {/* copyrights */}
            <p className="copyright">© 2023 MyPipeApp.com, All Rights Reserved.</p>
        </div >
    )
}

export default LandingPage;